
export const getMembershipsList = state => state.membershipState;
